import { type AddTabPanelInfo, TOTAL_DETAIL } from '@/common/stores/slide-detail';
import { DB_TYPE } from '@/common/define/common.define';
import type { SqlDetailParams } from './types';
import {
  getOracleSqlDetailAddition,
  getPostgresqlSqlDetailAddition,
  getMysqlSqlDetailAddition,
  getSqlServerSqlDetailAddition,
  getTiberoSqlDetailAddition,
  getAltibaseSqlDetailAddition,
  getRedshiftSqlDetailAddition,
  getSingleStoreSqlDetailAddition,
  getClickhouseSqlDetailAddition,
} from './db';
import { InvalidDatabaseTypeError } from './error.utils';
import { getSqlDetailTimePeriodByInterval } from './time.utils';

type Params = Omit<SqlDetailParams, 'dbType'> & { dbType?: string };

export const useSqlDetail = () => {
  const ADDITION_GETTER_OBJ = {
    [DB_TYPE.SQLSERVER]: getSqlServerSqlDetailAddition,
    [DB_TYPE.ORACLE]: getOracleSqlDetailAddition,
    [DB_TYPE.POSTGRESQL]: getPostgresqlSqlDetailAddition,
    [DB_TYPE.MYSQL]: getMysqlSqlDetailAddition,
    [DB_TYPE.TIBERO]: getTiberoSqlDetailAddition,
    [DB_TYPE.ALTIBASE]: getAltibaseSqlDetailAddition,
    [DB_TYPE.CLICKHOUSE]: getClickhouseSqlDetailAddition,
    [DB_TYPE.REDSHIFT]: getRedshiftSqlDetailAddition,
    [DB_TYPE.SINGLESTORE]: getSingleStoreSqlDetailAddition,
  };

  const getSqlDetailAddition = (
    params: Params,
  ): Extract<AddTabPanelInfo, { type: typeof TOTAL_DETAIL.SQL }> => {
    const { dbType = '', fromTime, toTime } = params;

    const additionGetterFn = ADDITION_GETTER_OBJ[dbType];
    if (!additionGetterFn) {
      throw new InvalidDatabaseTypeError({ dbType });
    }

    const sqlDetailTimeRange = getSqlDetailTimePeriodByInterval({ fromTime, toTime });
    const { name, addition } = additionGetterFn({ ...params, ...sqlDetailTimeRange });
    return {
      type: TOTAL_DETAIL.SQL,
      name,
      addition,
    };
  };

  return { getSqlDetailAddition };
};
